import { Controller } from "@hotwired/stimulus"
import { createIcons, icons } from 'lucide'

export default class extends Controller {
  static targets = ["truncatedBody", "expandedDetails"]
  static values = {
    completeUrl: String,
    expanded: { type: Boolean, default: false }
  }

  connect() {
    setTimeout(() => createIcons({ icons }), 0)
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.updateView()
  }

  updateView() {
    if (this.expandedValue) {
      // Show expanded view
      if (this.hasTruncatedBodyTarget) this.truncatedBodyTarget.classList.add("hidden")
      if (this.hasExpandedDetailsTarget) this.expandedDetailsTarget.classList.remove("hidden")
    } else {
      // Show collapsed view
      if (this.hasTruncatedBodyTarget) this.truncatedBodyTarget.classList.remove("hidden")
      if (this.hasExpandedDetailsTarget) this.expandedDetailsTarget.classList.add("hidden")
    }
    setTimeout(() => createIcons({ icons }), 0)
  }

  complete() {
    if (!this.completeUrlValue) return

    fetch(this.completeUrlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        // Visual feedback - add completed styling
        this.element.classList.add('opacity-60')
        // Collapse the card
        this.expandedValue = false
        this.updateView()
        // Reload to show updated state
        window.location.reload()
      }
    }).catch(err => {
      console.error("Failed to complete card:", err)
    })
  }
}
